import React from 'react';
import { Col, Input, Row } from 'antd';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import OrgHierarchySelector from '@totem/components/ui_components/widgets/hierarchySelector/orgHierarchySelector';
import { ObjectReference } from '@totem/types/common';

const { TextArea } = Input;

export interface OrgSelection {
  organization: ObjectReference;
  region: ObjectReference;
  building: ObjectReference;
  controlSystem: ObjectReference;
}

const OrgSelectorTest = () => {
  const [set1, setSet1] = React.useState<OrgSelection>(null);
  const [set2, setSet2] = React.useState<OrgSelection>(null);
  const [set3, setSet3] = React.useState<OrgSelection>(null);
  const [set4, setSet4] = React.useState<OrgSelection>(null);
  return (
    <ContentLayout>
      <IBCard isCovered>
        <Row>
          <Col span={12}>
            <OrgHierarchySelector
              showLabels
              showOrganization
              showRegions
              showBuildings
              showControlSystems
              onChange={(
                organization: ObjectReference,
                region: ObjectReference,
                building: ObjectReference,
                controlSystem: ObjectReference,
              ) => {
                setSet1({
                  organization,
                  region,
                  building,
                  controlSystem,
                });
              }}
            />
          </Col>
          <Col span={12}>
            <TextArea rows={18} value={JSON.stringify(set1, null, 2)} />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <OrgHierarchySelector
              showOrganization={false}
              showRegions={false}
              showBuildings
              showControlSystems
              onChange={(
                organization: ObjectReference,
                region: ObjectReference,
                building: ObjectReference,
                controlSystem: ObjectReference,
              ) => {
                setSet2({
                  organization,
                  region,
                  building,
                  controlSystem,
                });
              }}
            />
          </Col>
          <Col span={12}>
            <TextArea rows={18} value={JSON.stringify(set2, null, 2)} />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <OrgHierarchySelector
              showOrganization={false}
              showRegions={false}
              showBuildings
              showControlSystems={false}
              onChange={(
                organization: ObjectReference,
                region: ObjectReference,
                building: ObjectReference,
                controlSystem: ObjectReference,
              ) => {
                setSet3({
                  organization,
                  region,
                  building,
                  controlSystem,
                });
              }}
            />
          </Col>
          <Col span={12}>
            <TextArea rows={18} value={JSON.stringify(set3, null, 2)} />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <OrgHierarchySelector
              showOrganization={false}
              showRegions={false}
              showBuildings
              showControlSystems
              defaultRegionId={'5f2d5fd3a679f910caaa31db'}
              defaultBuildingId={'5f2d62cfa679f910caaa31e3'}
              onChange={(
                organization: ObjectReference,
                region: ObjectReference,
                building: ObjectReference,
                controlSystem: ObjectReference,
              ) => {
                setSet4({
                  organization,
                  region,
                  building,
                  controlSystem,
                });
              }}
            />
          </Col>
          <Col span={12}>
            <TextArea rows={18} value={JSON.stringify(set4, null, 2)} />
          </Col>
        </Row>
      </IBCard>
    </ContentLayout>
  );
};

export default OrgSelectorTest;
